import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { FilterBlock } from './FilterBlock';
import { SourceFilter } from './SourceFilter';
import { SeasonsFilter } from './SeasonsFilter';
import { InterestsFilter } from './InterestsFilter';
import { ParamsFilter } from './ParamsFilter';
import { RatingFilter } from './RatingFilter';
import S from '../../../../stores';

export interface FiltersProps {}

interface StyledFiltersProps extends JSSClassesProps<ComponentJSSClasses>, FiltersProps {}

export const Filters = observer((props: StyledFiltersProps) => {
    const { classes } = props;

    return (
        <aside className={classes.container}>
            <h3 className={classes.title}>Фильтры</h3>
            { S.hotelReviews.sortedTagsByReviewAmount.length ?
                <FilterBlock title={'Интересное в отзывах'}>
                    <InterestsFilter
                        availableTags={S.hotelReviews.availableTags}
                        sortedTagsByReviewAmount={S.hotelReviews.sortedTagsByReviewAmount}
                    />
                </FilterBlock>
                : null
            }
            <FilterBlock title={'Параметры'}>
                <ParamsFilter
                    reviewsAmount={S.hotelReviews.reviewsAmountToParamsFilters}
                />
            </FilterBlock>
            <FilterBlock title={'Оценка в отзывах'}>
                <RatingFilter />
            </FilterBlock>
            <FilterBlock title={'Источник отзывов'}>
                <SourceFilter sources={S.hotelReviews.foundSources} />
            </FilterBlock>
            <FilterBlock title={'Сезон'}>
                <SeasonsFilter
                    reviewsAmount={S.hotelReviews.reviewsOverview.amountBySeasons}
                />
            </FilterBlock>
        </aside>
    );
});
